import React, { FC, ReactNode, useRef } from "react"
import useScrollTrigger from "./hooks/useScrollTrigger"
import { m } from "framer-motion"

interface SimpleFadeTextAnimationProps {
  children: ReactNode
  delay?: string | number
  threshold?: number
  isTriggered?: boolean
  display?: string
}

const SimpleFadeTextAnimation: FC<SimpleFadeTextAnimationProps> = ({
  delay = 0,
  children,
  threshold = 0.5,
  isTriggered,
  display = "block",
}) => {
  const wrapperRef = useRef()
  const { isTriggered: localIsTriggered } = useScrollTrigger({
    wrapperRef,
    threshold,
  })
  const finalIsTriggered = isTriggered != null ? isTriggered : localIsTriggered

  return (
    <div ref={wrapperRef} style={{ display: display }}>
      <m.div
        animate={{
          opacity: finalIsTriggered ? 1 : 0,
          y: finalIsTriggered ? 0 : 50,
        }}
        transition={{ duration: 0.5, delay: finalIsTriggered ? delay : 0 }}
      >
        {children}
      </m.div>
    </div>
  )
}

export default SimpleFadeTextAnimation
